import "./DevPage.css";
import { DashboardPage, createDashboardLayout } from "../components/DashboardPage/DashboardPage.jsx";
import { Panel } from "../components/Panel/Panel.jsx";
import "../features/settings/settings-ui.css";

const devPageLayout = createDashboardLayout({
  columns: [
    { size: "fill" }
  ],
  rows: [
    { size: "fill" }
  ],
  areas: [
    ["hub"]
  ]
});

export function DevPage({ onNavigateToPage }) {
  return (
    <DashboardPage
      layout={devPageLayout}
      slots={[
        {
          key: "hub",
          area: "hub",
          fill: false,
          content: (
            <Panel
              padded
              className="dev-page-panel"
              header="Dev"
            >
              <div class="dev-page">
                <p class="dev-page-copy">
                  Internal helpers and inspectors live here.
                </p>

                <button
                  class="settings-action-button primary"
                  type="button"
                  onClick={() => onNavigateToPage?.("dev", "projection-formula")}
                >
                  Projection Formula
                </button>
              </div>
            </Panel>
          )
        }
      ]}
    />
  );
}
